import request from '../request'

export const getAssessmentSummary = () => request.get('/analytics/query/assessment/summary')

export const getAssessmentByMonth = () => request.get('/analytics/query/assessment/by-month')

// MF-399 — progreso por (assessment, round, question): base de la Cohort View.
export const getRoundProgress = (params = {}) =>
  request.get('/analytics/query/assessment/round-progress', {
    params: {
      ...(params.assessmentId ? { assessmentId: params.assessmentId } : {}),
      ...(params.finalizedOnly ? { finalizedOnly: true } : {})
    }
  })

export const getSurveyCompletion = (surveyId) =>
  request.get('/analytics/query/survey/completion', { params: surveyId ? { surveyId } : {} })

export const getIngestStatus = () => request.get('/analytics/ingest/status')

// MF-541 — pass { scope: 'tenant' } to refresh only this school (per-tenant), or {} for the full
// cluster rebuild. The BE proxy forwards the body + X-Tenant-Id to the analytics service.
export const triggerIngest = (body = {}) => request.post('/analytics/ingest', body)

// ── MF-507 PAT (ACER OARS) ────────────────────────────────────────────────────
export const getPatSummary = (params) => request.get('/analytics/query/pat/summary', { params: params || {} })

export const getPatResults = (params) => request.get('/analytics/query/pat/results', { params: params || {} })

export const getPatBandDistribution = (params) =>
  request.get('/analytics/query/pat/band-distribution', { params: params || {} })

export const getPatCoverage = () => request.get('/analytics/query/pat/coverage')

// ── MF-508 PAT item-level ──────────────────────────────────────────────────────
export const getPatStudentItems = (params) =>
  request.get('/analytics/query/pat/student-items', { params: params || {} })

export const getPatItemCohort = (params) =>
  request.get('/analytics/query/pat/item-cohort', { params: params || {} })

// ── MF-506 IA asistente ─────────────────────────────────────────────────────────
// Envía la conversación al asistente; devuelve un AgentResult (clarify | chart | error).
export const aiChat = (messages) => request.post('/analytics/ai/chat', { messages })

// Gráficas guardadas (historial por usuario). Endpoints NATIVOS del BE (no proxy a analytics).
export const aiSaveChart = (payload) => request.post('/ai-charts', payload)
export const aiListCharts = () => request.get('/ai-charts')
export const aiGetChart = (id) => request.get(`/ai-charts/${id}`)
export const aiRenameChart = (id, label) => request.put(`/ai-charts/${id}`, { label })
export const aiDeleteChart = (id) => request.delete(`/ai-charts/${id}`)

// Inteligencia de demanda (agregados del ConversationLog del tenant). Maestro-only en el FE.
export const aiInsights = () => request.get('/analytics/ai/insights')

// Estructura de datos disponible (catálogo) para que el usuario sepa qué puede consultar.
export const aiSchema = () => request.get('/analytics/ai/schema')
